import { useDisclosure } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import LogoLoader from 'components/Loader/LogoLoader';
import { routePaths } from 'global/routePaths';
import { useParamsQuery } from 'hooks/common/useParamsQuery';
import { useSingleRejectRequest } from 'hooks/timeOff/useSingleRejectRequests';
import toaster from 'utils/toaster';

import RequestApproveConfirmationModal from '../Modal/RequestApprovalConfirmationModal';
import { initialApproveFormData } from '../Modal/RequestApprovalConfirmationModal/schema';

const TimeOffRequests: React.FC<unknown> = () => {
  const { t } = useTranslation(['timeOff']);

  const [approveModalFormData, setApproveModalFormData] =
    useState<typeof initialApproveFormData>(initialApproveFormData);

  const navigate = useNavigate();
  const searchParams = useParamsQuery();

  const {
    isOpen: isApprovalConfirmationModalOpen,
    onOpen: onApprovalConfirmationModalOpen,
    onClose: onApprovalConfirmationModalClose,
  } = useDisclosure();

  const { mutateAsync: singleRejectRequestMutateAsync } = useSingleRejectRequest();

  useEffect(() => {
    const id = searchParams.get('id');
    const reqStatus = searchParams.get('status');
    const isPaid = searchParams.get('is_paid');

    if (!id || !(reqStatus === 'approve' || reqStatus === 'reject')) {
      toaster.error({ description: t('timeOff:youAreNotAllowedToVisitThisPage') });
      navigate(routePaths.timeOff.base.route, { replace: true });
    }

    if (reqStatus === 'approve') {
      setApproveModalFormData({ ...approveModalFormData, timesheet_entry: isPaid === '1' ? ['yes'] : [] });
      onApprovalConfirmationModalOpen();
    }

    if (reqStatus === 'reject') {
      const postData = {
        time_off_entry_id: +(id ?? 0),
      };
      singleRejectRequestMutateAsync(postData)
        .then(() => {
          navigate(routePaths.timeOff.requests.reject);
        })
        .catch(() => {
          navigate(routePaths.timeOff.base.route, { replace: true });
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRequestApprovalSuccess = () => {
    navigate(routePaths.timeOff.requests.accept);
  };

  const handleModalClose = () => {
    onApprovalConfirmationModalClose();
    navigate(routePaths.timeOff.base.route, { replace: true });
  };

  return (
    <>
      <LogoLoader />
      <RequestApproveConfirmationModal
        isModelOpen={isApprovalConfirmationModalOpen}
        onModalClose={handleModalClose}
        dialogIds={{ ids: [+(searchParams.get('id') || [])] }}
        handleApproveSuccess={handleRequestApprovalSuccess}
        formData={approveModalFormData}
      />
    </>
  );
};

export default TimeOffRequests;
